import { useGlobalModal } from 'components/GlobalModal/globalModal';

export const useShopperModals = () => {
  const { showModal, hideModal } = useGlobalModal();

  const showShopperModal = () => {
    import('components/shopper/components/modals/ShopperModal').then(
      (module) => {
        showModal({
          children: <module.default />,
          style: { width: 1177, padding: 0 },
        });
      },
    );
  };

  const showLearnMoreModal = () => {
    import('components/shopper/components/modals/ShopperLearnMoreModal').then(
      (module) => {
        showModal({
          children: <module.default />,
          style: { width: 1130, padding: 0 },
        });
      },
    );
  };

  const showDemoModal = () => {
    import('components/shopper/components/modals/ShopperDemoModal').then(
      (module) => {
        showModal({
          children: <module.default />,
          style: { width: 1070, padding: 0 },
        });
      },
    );
  };

  const showCancelShopperModal = () => {
    import('components/shopper/components/modals/CancelShopperModal').then(
      (module) => {
        showModal({
          children: <module.default />,
          style: { width: 630 },
        });
      },
    );
  };

  const showWelcomeModal = () => {
    import('components/shopper/components/modals/ShopperWelcomeModal').then(
      (module) => {
        showModal({
          children: <module.default />,
          style: { width: 690, height: 656, padding: 0 },
        });
      },
    );
  };

  const showContinueToBrandCenterModal = () => {
    import(
      'components/shopper/components/modals/ContinueToBrandCenterModal'
    ).then((module) => {
      showModal({
        children: <module.ContinueToBrandCenterShopperModal />,
        style: { width: 690, height: 656, padding: 0 },
      });
    });
  };

  const showActivationSuccessModal = () => {
    import(
      'components/shopper/components/modals/ShopperActivationSuccessModal'
    ).then((module) => {
      showModal({
        children: <module.ShopperActivationSuccessModal onClose={hideModal} />,
        style: { width: 600, height: 700, padding: 0 },
      });
    });
  };

  return {
    hideModal,
    showShopperModal,
    showLearnMoreModal,
    showDemoModal,
    showCancelShopperModal,
    showWelcomeModal,
    showContinueToBrandCenterModal,
    showActivationSuccessModal,
  };
};
